import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import CommonNav from "../main/CommonNav";
import Footer from "../main/Footer";
import Loading from "../lib/Loading";

import BuddibleSocket from "../lib/BuddibleSocket";
import CodeList from "../lib/CodeList";
import Utilities from "../lib/Utilities";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

export default function DeleteAccount() {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const controller = {
    COMP_CD: useRef(),
    USER_ID: useRef(),
    RET_EMAIL: useRef(),
    REASON: useRef(),
    USER_NM: useRef(),
  };

  useEffect(() => {
    i18n.changeLanguage(i18n.language);
  }, []);

  function checkValidation() {
    if (controller.COMP_CD.current.value.trim() === "") {
      codeList.Modal.current.alert(t("commonMSG.enterCompanyCode"), () => {
        controller.COMP_CD.current.focus();
      });
      return true;
    }
    if (controller.USER_NM.current.value.trim() === "") {
      codeList.Modal.current.alert(t("commonMSG.enterName"), () => {
        controller.USER_NM.current.focus();
      });
      return true;
    }
    if (controller.USER_ID.current.value.trim() === "") {
      codeList.Modal.current.alert(t("commonMSG.enterID"), () => {
        controller.USER_ID.current.focus();
      });
      return true;
    }
    if (controller.RET_EMAIL.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("deleteAccount.msg.enterReplyEmail"),
        () => {
          controller.RET_EMAIL.current.focus();
        }
      );
      return true;
    }
    if (controller.REASON.current.value.trim() === "") {
      codeList.Modal.current.alert(t("deleteAccount.msg.enterReason"), () => {
        controller.REASON.current.focus();
      });
      return true;
    }

    return false;
  }

  function requestDeleteAccount() {
    if (checkValidation()) return;
    setIsLoading(true);
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/contact_me.php",
      msgID: msgID,
      COMP_CD: controller.COMP_CD.current.value,
      USER_ID: controller.USER_ID.current.value,
      RET_EMAIL: controller.RET_EMAIL.current.value,
      REASON: controller.REASON.current.value,
      USER_NM: controller.USER_NM.current.value,
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        setIsLoading(false);
        if (newData["ret"]) {
          codeList.Modal.current.alert(t("deleteAccount.msg.success"), () => {
            window.location.replace("/");
          });
        } else {
          codeList.Modal.current.alert(t("commonMSG.error"));
        }
      }
    });
  }

  return (
    <>
      <CommonNav />
      {isLoading && <Loading />}
      <main style={{ marginTop: 55 }}>
        <div className="container margin_60">
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <div>
                <h4 className="font-weight-bold mb-2">
                  {t("deleteAccount.title")}
                </h4>
                <p>{t("deleteAccount.description")}</p>
              </div>
              <div className="my-3">
                <h6 className="mb-1">{t("deleteAccount.processTitle")}</h6>
                <p>{t("deleteAccount.processStep1")}</p>
                <p>{t("deleteAccount.processStep2")}</p>
                <p>
                  {t("deleteAccount.processStep3-1")}
                  <Link to="/Terms/privacyPolicy">
                    {t("deleteAccount.seeDetails")}
                  </Link>
                  {t("deleteAccount.processStep3-2")}
                </p>
              </div>

              <div>
                <div className="mb-2">
                  <p>{t("deleteAccount.form.companyCode")}</p>
                  <input className="form-control" ref={controller.COMP_CD} />
                </div>
                <div className="mb-2">
                  <p>{t("deleteAccount.form.userName")}</p>
                  <input className="form-control" ref={controller.USER_NM} />
                </div>
                <div className="mb-2">
                  <p>{t("deleteAccount.form.account")}</p>
                  <input className="form-control" ref={controller.USER_ID} />
                </div>
                <div className="mb-2">
                  <p>{t("deleteAccount.form.replyEmail")}</p>
                  <input className="form-control" ref={controller.RET_EMAIL} />
                </div>
                <div className="mb-2">
                  <p>{t("deleteAccount.form.reason")}</p>
                  <textarea
                    className="form-control"
                    ref={controller.REASON}
                    rows={5}
                  />
                </div>
                <p className="text-danger font-weight-bold mb-2">
                  {t("deleteAccount.notice")}
                </p>
                <div className="text-center">
                  <button
                    className="btn_1"
                    onClick={() => requestDeleteAccount()}
                  >
                    {t("deleteAccount.submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
